

















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { Base } from '@/components/common/base';
import { storeService } from '@/shared';
import { RedrockAccountAddOrUpdateViewModel } from '@/models/payment/redrockAccount';

@Component({
    props: ['methodName', 'progress'],
    computed: {
        methodtoCall: {
            get() {
                return this.$props.methodName;
            },
        },
    },
})
export default class AddRedrockAccountPage extends Base {
    public vm: RedrockAccountAddOrUpdateViewModel = new RedrockAccountAddOrUpdateViewModel();
    public form: any = {};
    public formFields: Array<VFields<any>> = [];
    public disableSubmitButton: boolean = false;
    public tenantId: number = 0;
    public enterpriseId: number = 0;
    public redRockEnvironment: string = "";
    public created(): void {
        this.setFields();
    }

    public beforeDestroy() {
        const buttons = [];
        this.$emit('updateToolBar', buttons);
    }
    public callMethod(methodName): void {
        if (methodName === 'backToStoreEdit') {
            this.$router
                .push({
                    name: 'admin.stores.edit',
                    params: { id: this.vm.storeId.toString(), tab: 'RedrockAccount' },
                })
                .catch((ex) => {
                    console.log(ex);
                });
        } else if (methodName === 'submit') {
            if (!this.form.$valid) {
                this.showAlert(false, this.$t('cenposAccounts.alertFormInvalid'));
                this.resetMethodName(methodName);
                return;
            }
            this.submitRedrockAccount();
        } else {
            console.log(methodName);
        }
        this.resetMethodName(methodName);
    }
    public resetMethodName(methodName): void {
        if (methodName !== '') {
            this.$emit('resetMethodName', methodName);
        }
    }
    public updateToolBar(): void {
        const buttons: any = [];
        buttons.push({
            id: '0',
            type: 'button',
            title: this.$parent.$t('stores.btnBackToStoreTitle'),
            disabled: false,
            visible: true,
            class: 'btn',
            label: this.$parent.$t('stores.btnBack'),
            click: 'backToStoreEdit',
            icon: 'fas fa-arrow-left',
        });
        this.$emit('updateToolBar', buttons);
    }
    public mounted() {
        // Toolbar
        this.updateToolBar();
        this.$watch('methodtoCall', (newVal, oldVal) => {
            if (newVal) {
                this.callMethod(newVal);
            }
        });
        this.setFields();
        this.vm.storeId = Number(this.$route.params.storeId);
        this.getRedrockAccountDetails();
    }

    public setFields(): void {
        this.formFields = [
            {
                key: 'environment',
                required: true,
                type: 'v-alynk-select',
                templateOptions: {
                    disabled: false,
                    required: true,
                    label: 'Environment',
                    items: [
                        'Production',
                        'Sandbox',
                    ],
                    loading: false,
                    rules: [
                        v => this.required('Environment', v)
                    ], events: {
                        onChange: (items, value) => {
                            this.redRockEnvironment = value;
                            this.getRedrockAccountDetails();
                        },
                    },
                },
            },
            {
                key: 'username',
                type: 'v-alynk-text-field',
                required: true,
                templateOptions: {
                    counter: 100,
                    label: 'Username',
                    required: true,
                    disabled: false,
                    rules: [
                        v => this.required('Username', v)
                    ]
                },
            },
            {
                key: 'password',
                type: 'v-alynk-text-field',
                required: true,
                templateOptions: {
                    counter: 100,
                    label: 'Password',
                    required: false,
                    disabled: false,
                },
            },
            {
                key: 'hostedFieldKey',
                type: 'v-alynk-text-field',
                required: true,
                templateOptions: {
                    counter: 100,
                    label: 'Hosted Field Source Key',
                    required: true,
                    disabled: false,
                    rules: [
                        v => this.required('Hosted Field Source Key', v)
                    ]
                },
            },
            {
                key: 'uri',
                type: 'v-alynk-text-field',
                required: true,
                templateOptions: {
                    counter: 100,
                    label: 'Uri',
                    required: true,
                    disabled: false,
                    rules: [
                        v => this.required('Base Uri', v)
                    ]
                },
            },
            {
                key: 'hostedFieldCdnUri',
                type: 'v-alynk-text-field',
                required: true,
                templateOptions: {
                    counter: 100,
                    label: 'Hosted Field Cdn Uri',
                    required: true,
                    disabled: false,
                    rules: [
                        v => this.required('Hosted Field Cdn Uri', v)
                    ]
                },
            }
        ];
    }

    public validateRedrockAccount(): Vue & { validate: () => boolean } {
        return this.$refs.RedrockAccountForm as Vue & { validate: () => boolean };
    }

    public async submitRedrockAccount(): Promise<void> {
        if (this.validateRedrockAccount().validate()) {
            try {
                this.disableSubmitButton = true;
                this.$emit('update:progress', this.disableSubmitButton);
                await storeService.updateRedrockAccounts(
                    this.vm.storeId,
                    this.vm.account
                );
                this.showAlert(true, 'Redrock Account Successfully saved');
                this.$router.push({
                    name: 'admin.stores.edit',
                    params: {
                        tenantId: this.tenantId.toString(),
                        enterpriseId: this.enterpriseId.toString(),
                        storeId: this.vm.storeId.toString(),
                        tab: 'RedrockAccount'
                    },
                });
            } finally {
                this.disableSubmitButton = false;
                this.$emit('update:progress', this.disableSubmitButton);
            }
        }
    }

    public async getRedrockAccountDetails(): Promise<void> {
        try {
            this.disableSubmitButton = true;
            this.$emit('update:progress', this.disableSubmitButton);
            this.formlyShowSkeleton(this.formFields);
            const response = await storeService.getRedrockAccountDetails(
                this.vm.storeId,
                this.redRockEnvironment
            );
            if (response) {
                this.vm.account = response;
            }
        } finally {
            this.redRockEnvironment = "";
            this.formlyHideSkeleton(this.formFields);
            this.disableSubmitButton = false;
            this.$emit('update:progress', this.disableSubmitButton);
        }
    }
}
